module.exports = __webpack_public_path__ + "static/media/26.6ce09391.png";